import { RootState } from 'store';
import { resetAccountState } from 'modules/account/store/accountSlice';
import { resetPersonalAccountSlice } from 'modules/personalAccount/store/personalAccountSlice';
import { selectUserAddress } from 'modules/user/store/selectors';
import { web3Api } from 'store/queries';
import { selectIsLoggedIn } from 'modules/auth/store/selectors';

import { gateways } from '../const';
import { resetAuthSlice } from '../store/authSlice';

export const {
  endpoints: { signOut },
  useSignOutMutation,
} = web3Api.injectEndpoints({
  endpoints: build => ({
    signOut: build.mutation<boolean, void>({
      queryFn: async (_args, { dispatch, getState }) => {
        const authAddress = selectUserAddress(getState() as RootState);
        const isLoggedIn = selectIsLoggedIn(getState() as RootState);

        if (isLoggedIn) {
          try {
            await gateways.auth.signOut();
          } catch (error) {
            // eslint-disable-next-line no-console
            console.warn(error);
          }
        }

        if (authAddress) {
          dispatch(resetAccountState(authAddress));
        }

        dispatch(resetPersonalAccountSlice());
        dispatch(resetAuthSlice());
        dispatch(web3Api.util.resetApiState());

        return { data: true };
      },
    }),
  }),
});
